var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { BarGraphElement } from '../bar-graph.element';
import { CharacterElement } from '../character.element';
import { DateTimeElement } from '../date-time.element';
import { EllipseElement } from '../ellipse-element';
import { HistoryCurveElement } from '../history-curve.element';
import { ImageElement } from '../image.element';
import { MeterElement } from '../meter.element';
import { NumericalDisplayElement } from '../numerical-display.element';
import { PipeElement } from '../pipe.element';
import { RectangleElement } from '../rectangle.element';
import { RingGraphElement } from '../ring-graph/ring-graph.element';
import { SectorElement } from '../sector.element';
import { SwitchIndicatorLightElement } from '../switch-indicator-light.element';
import { TextElement } from '../text.element';
import { HyperlinkElement } from '../hyperlink.element';
import { ToggleViewElement } from '../toggle-view.element';
import { PolyLineElement } from '../poly-line/poly-line.element';
import { StraightLineElement } from '../straight-line/straight-line.element';
import { PolygonElement } from '../polygon/polygon.element';
import { VideoElement } from '../video.element';
import { TableElement } from '../table/table.element';
import { WeatherElement } from '../weather-element';
var ElementFactory = /** @class */ (function () {
    function ElementFactory(injector) {
        this.nodeElements = new Array();
        this.linkElements = new Array();
        this.nodeElements.push(new ImageElement(injector));
        this.nodeElements.push(new TextElement(injector));
        this.nodeElements.push(new HyperlinkElement(injector));
        this.nodeElements.push(new NumericalDisplayElement(injector));
        this.nodeElements.push(new MeterElement(injector));
        this.nodeElements.push(new SwitchIndicatorLightElement(injector));
        this.nodeElements.push(new BarGraphElement(injector));
        this.nodeElements.push(new ToggleViewElement(injector));
        this.nodeElements.push(new PipeElement(injector));
        this.nodeElements.push(new CharacterElement(injector));
        this.nodeElements.push(new PolyLineElement(injector));
        this.nodeElements.push(new StraightLineElement(injector));
        this.nodeElements.push(new RectangleElement(injector));
        this.nodeElements.push(new EllipseElement(injector));
        this.nodeElements.push(new SectorElement(injector));
        this.nodeElements.push(new DateTimeElement(injector));
        this.nodeElements.push(new HistoryCurveElement(injector));
        this.nodeElements.push(new RingGraphElement(injector));
        this.nodeElements.push(new PolygonElement(injector));
        this.nodeElements.push(new VideoElement(injector));
        this.nodeElements.push(new TableElement(injector));
        this.nodeElements.push(new WeatherElement(injector));
        ElementFactory_1.allElements = this.nodeElements.concat(this.linkElements);
    }
    ElementFactory_1 = ElementFactory;
    var ElementFactory_1;
    ElementFactory.allElements = new Array();
    ElementFactory = ElementFactory_1 = __decorate([
        Injectable()
    ], ElementFactory);
    return ElementFactory;
}());
export { ElementFactory };
